<template>
    <BlogForm></BlogForm>
</template>
<script>
import BlogForm from '@/components/BlogComponents/BlogForm.vue';
export default {
    components:{
        BlogForm,
    }
    
}
</script>
<style>

</style>